export type TIDBDatabase = {
  name: string;
  version?: number;
  tables?: Array<TIDBTable>;
};

export type TIDBTable = {
  name: string;
  keyPath?: string | Array<string>;
  indices?: Array<TIDBIndex>;
  autoIncrement: boolean;
};

export type TIDBIndex = {
  name: string;
  keyPath?: string | Array<string>;
  multiEntry?: boolean;
  unique?: boolean;
};

//--------------------------------------------------------------------------------------------

export type CacheItem = {
  cacheInfo: string | null;
  data: unknown;
};

export type TIDBConnection = TIDBDatabase;

export const STORAGE_KEYS = {
  AUTHENTICATION: {
    USER: 'authentication/user',
    USER_PREFERENCES: 'authentication/userPreferences',
  },
  TAXONOMY: {
    TAXONOMY_MAIN: 'taxonomy/sector/all',
    TAXONOMY_CROSS_STRATEGY_TAGS: 'taxonomy/crossstrategytag/all',
    TAXONOMY_ASSET_CLASS_SUBSTRATEGY: 'taxonomy/assetclasssubstrategy/all',
    UNIVERSAL_TAGS: 'taxonomy/universalTags',
    ASSET_CLASS_TAGS: 'taxonomy/assetClassTags',
  },
} as const;
